import { Dialog } from "@headlessui/react";
import { Icon } from "@iconify/react";
import queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { useInView } from "react-intersection-observer";
import { Slide } from "react-reveal";
import Fade from "react-reveal/Fade";
import { useLocation, useNavigate } from "react-router-dom";
import { useDraggable } from "react-use-draggable-scroll";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import ic_cancel from "../../assets/icons/ic_cancel.svg";
import ic_tick from "../../assets/icons/ic_check.svg";
import healthyLife from "../../assets/images/healthy_life.png";
import perfect_vision_logo from "../../assets/images/perfect_vision_logo.png";
import { useAuthContext } from "../../context/AuthContext";
import useIsMobile from "../../utils/useIsMobile";
import AuthDialog from "../auth/AuthDialog";
import CustomDialog from "../basic/Dialog";
import { TestYourFitness, UserDetailsPopUp } from "./FitnessFreaks";
import Testimonials from "./Testimonials";
// import newHeroImage from "../../assets/images/ploted_hero_image.png";
import newMobileHeroImage from "../../assets/images/mobile_Hero_Img.png";
// import MarketingFitness from "./MarketingFitnessSection";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import web_hero_img from "../../assets/images/web_hero_img.png";
import { validateEmail } from "../../utils/Utils";
import "./ExitIntent.css";
// import ic_close from "../../assets/icons/ic_close.svg";
// import Button from "../basic/Button";
// import IconButton from "../basic/IconButton";
// import OtpInput from "../basic/OtpInput";
import {
    getIpDetials,
    postCreateLead
} from "../../api/api";

// Exist-Intent Pop-Up for Desktop/Laptop
function ExitIntentPopup() {
  const [email, setEmail] = useState();
  const [intentClose, setIntentClose] = useState(false);
  const exit = (e) => {
    const shouldExit =
      [...e.target.classList].includes("exit-intent-popup") || // user clicks on mask
      e.target.id === "close" || // user clicks on the close icon
      e.keyCode === 27; // user hits escape

    if (shouldExit) {
      document.querySelector(".exit-intent-popup").classList.remove("visible");
    }
  };

  const mouseEvent = (e) => {
    const shouldShowExitIntent =
      !e.toElement && !e.relatedTarget && e.clientY < 10;

    if (shouldShowExitIntent) {
      document.removeEventListener("mouseout", mouseEvent);
      document.querySelector(".exit-intent-popup").classList.add("visible");

      // CookieService.setCookie("exitIntentShown", true, 30);
      // CookieService.setCookie("exitIntentShown", true, 0);
    }
  };

  // const CookieService = {
  //   setCookie(name, value, days) {
  //     let expires = "";

  //     if (days) {
  //       const date = new Date();
  //       // date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  //       date.setTime(date.getTime() + days * 0 * 60 * 60 * 1000);
  //       expires = "; expires=" + date.toUTCString();
  //     }

  //     document.cookie = name + "=" + (value || "") + expires + ";";
  //   },

  //   getCookie(name) {
  //     const cookies = document.cookie.split(";");

  //     for (const cookie of cookies) {
  //       if (cookie.indexOf(name + "=") > -1) {
  //         return cookie.split("=")[1];
  //       }
  //     }

  //     return null;
  //   },
  // };

  // if (!CookieService.getCookie("exitIntentShown")) {
  setTimeout(() => {
    document.addEventListener("mouseout", mouseEvent);
    document.addEventListener("keydown", exit);
    document
      .querySelector(".exit-intent-popup")
      .addEventListener("click", exit);
  }, 0);
  // }

  return (
    <div className="exit-intent-popup lg:block hidden">
      <div className="newsletter rounded-lg bg-[#0C101B] text-center shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
        <p className="text-white font-normal font-poppins flex justify-center opacity-75">
          Before you go... Getting fit requires huge commitments. You may not
          have the time now. <br />
          Take the first step, share your email. We will email on OFFER worth
          INR 5k in value.
          {/* <span className="text-primary-neonGreen">OFFER worth INR 5k </span>in
          value. */}
        </p>
        <input
          type="email"
          placeholder="Enter your email"
          className="email my-8 px-4 py-3 w-68 text-center rounded-md border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <div className="grid grid-cols-2 gap-8 my-6">
          <button
            className="submit text-sm px-2 py-2 mx-5 bg-primary-neonGreen rounded-sm shadow-lg"
            onClick={async () => {
              if (email == "") {
                toast("Email is required", { type: "error" });
              } else if (!validateEmail(email)) {
                toast("Invalid email", { type: "error" });
              } else {
                // setEmail(e.target.value);
              }
            }}
          >
            Grab Your Offer
          </button>
          <button
            className="text-sm px-2 py-2 mx-5 bg-primary-orange text-white rounded-sm shadow-lg"
            id="close"
            onClick={() => {
              // setIntentClose(false);
            }}
          >
            I don't like discount
          </button>
        </div>
      </div>
    </div>
  );
}

// Pop-Mob
function MobPopup() {
  const [showPopup, setShowPopup] = useState(false);
  const [intentClose, setIntentClose] = useState(false);
  const [email, setEmail] = useState();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowPopup(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {showPopup && (
        <div className="fixed bottom-0 left-0 right-0 p-4 bg-white shadow-lg rounded-t-md">
          {/* <div className="exit-intent-popup">
            <div className="newsletter rounded-lg bg-[#0C101B] text-center shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
              <p className="text-white font-normal font-poppins flex justify-center opacity-75">
                Before you go... Getting fit requires huge commitments. You may
                not have the time now. <br />
                Take the first step, share your email. We will email on OFFER
                worth INR 5k in value.
              </p>
              <input
                type="email"
                placeholder="Enter your email"
                className="email my-8 px-4 py-3 w-68 text-center rounded-md border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <div className="grid grid-cols-2 gap-8 my-6">
                <button
                  className="submit text-sm px-2 py-2 mx-5 bg-primary-neonGreen rounded-sm shadow-lg"
                  onClick={async () => {
                    if (email == "") {
                      toast("Email is required", { type: "error" });
                    } else if (!validateEmail(email)) {
                      toast("Invalid email", { type: "error" });
                    } else {
                      // setEmail(e.target.value);
                    }
                  }}
                >
                  Grab Your Offer
                </button>
                <button
                  className="text-sm px-2 py-2 mx-5 bg-primary-orange text-white rounded-sm shadow-lg"
                  id="close"
                  onClick={() => {
                    setIntentClose(false);
                    // close();
                  }}
                >
                  I don't like discount
                </button>
              </div>
            </div>
          </div> */}
          <p>Mobile Exit Intent Popup</p>
        </div>
      )}
    </>
  );
}

// Exit-Intent-Popup for Mobile
function MobilePopup() {
  const [email, setEmail] = useState("");
  const [intentClose, setIntentClose] = useState(false);
  const [timerId, setTimerId] = useState(null);

  const exit = (e) => {
    const shouldExit =
      [...e.target.classList].includes("exit-intent-popup") ||
      e.target.id === "close" ||
      e.keyCode === 27;

    if (shouldExit) {
      document.querySelector(".exit-intent-popup").classList.remove("visible");
    }
  };

  const timerEvent = () => {
    setTimerId(
      setTimeout(() => {
        document.querySelector(".exit-intent-popup").classList.add("visible");
        CookieService.setCookie("exitIntentShown", true, 30);
      }, 1000) // 15 seconds
    );
  };

  const CookieService = {
    setCookie(name, value, days) {
      let expires = "";

      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + ";";
    },

    getCookie(name) {
      const cookies = document.cookie.split(";");
      for (const cookie of cookies) {
        if (cookie.indexOf(name + "=") > -1) {
          return cookie.split("=")[1];
        }
      }
      return null;
    },
  };

  useEffect(() => {
    if (!CookieService.getCookie("exitIntentShown")) {
      setTimerId(setTimeout(timerEvent, 1000)); // 15 seconds
    }

    document.addEventListener("keydown", exit);
    document
      .querySelector(".exit-intent-popup")
      .addEventListener("click", exit);

    return () => {
      clearTimeout(timerId);
      document.removeEventListener("keydown", exit);
      document
        .querySelector(".exit-intent-popup")
        .removeEventListener("click", exit);
    };
  }, []);
  return (
    <div className="exit-intent-popup">
      <div className="newsletter rounded-lg bg-[#0C101B] text-center shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
        <p className="text-white font-normal font-poppins flex justify-center opacity-75">
          Before you go... Getting fit requires huge commitments. You may not
          have the time now. <br />
          Take the first step, share your email. We will email on OFFER worth
          INR 5k in value.
        </p>
        <input
          type="email"
          placeholder="Enter your email"
          className="email my-8 px-4 py-3 w-68 text-center rounded-md border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <div className="grid grid-cols-2 gap-8 my-6">
          <button
            className="submit text-sm px-2 py-2 mx-5 bg-primary-neonGreen rounded-sm shadow-lg"
            onClick={async () => {
              if (email == "") {
                toast("Email is required", { type: "error" });
              } else if (!validateEmail(email)) {
                toast("Invalid email", { type: "error" });
              } else {
                // setEmail(e.target.value);
              }
            }}
          >
            Grab Your Offer
          </button>
          <button
            className="text-sm px-2 py-2 mx-5 bg-primary-orange text-white rounded-sm shadow-lg"
            id="close"
            onClick={() => {
              setIntentClose(false);
              // close();
            }}
          >
            I don't like discount
          </button>
        </div>
      </div>
    </div>
  );
}

function ExitIntentMobile() {
  const [timerId, setTimerId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const handleMouseMove = () => {
      clearTimeout(timerId);
      setTimerId(setTimeout(() => setShowPopup(true), 15000));
    };

    const hidePopup = () => {
      setShowPopup(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("click", hidePopup);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("click", hidePopup);
      clearTimeout(timerId);
    };
  }, [timerId]);

  return (
    <CustomDialog className="lg:hidden block">
      <Dialog.Panel className="rounded-lg bg-[#0C101B] text-center shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
        {showPopup && <MobilePopup close={() => setShowPopup(false)} />}
      </Dialog.Panel>
    </CustomDialog>
  );
}

// Product Hunt Banner
function ProductHunt() {
  return (
    <div className="bg-[#D25C38] text-[#FFFFFF] h-12 w-full text-xl sticky font-semibold">
      <div className="flex justify-center">
        <a href="https://www.producthunt.com/products/getactyv">
          <p className="font-poppins underline py-1">
            we’re live on Product Hunt! 🎉
          </p>
        </a>
      </div>
    </div>
  );
}

function HeroSection({ openAuth }) {
  const isMobile = useIsMobile();
  const [slideNumber, setSlideNumber] = useState(0);
  const [dialogShow, setDialogShow] = useState(false);
  const intervalRef = useRef();
  const navigate = useNavigate();

  const trackingPoint = () => {
    const queryParams = queryString.stringify({
      // utm_source: 'my_source',
      // utm_medium: 'my_medium',
      // utm_campaign: 'my_campaign',
      ref: "login_startFreeTrail",
    });
    // const url = `https://http://app.getactyvphysio.com/newLogin/?${queryParams}`;
    // window.location.href = url;
    navigate(`newLogin/?${queryParams}`);
  };

  const slides = [
    {
      title: (
        <Slide left>
          <p className="capitalize font-poppins  text-white font-extrabold text-5xl md:text-9xl leading-none px-5 md:px-32 mt-20">
            <span className="text-primary-neonGreen italic">
              {/* ACE </span>YOUR <br /> HEALTH */}
              DO{" "}
            </span>
            IT <br /> RIGHT
          </p>
          <p className="font-open-sans mt-2 text-white text-xl md:text-3xl font-bold px-5 md:px-32 ">
            {/* Get fit the right way with GetActyv's Virtual Personal Trainer */}
            Get fit the right way with GetActyv
            {/* with our AI based coach */}
            {/* #LikeNeverBefore */}
          </p>
        </Slide>
      ),
      component: (
        // <Slide left>
        //   <video
        //     className="absolute top-0 h-screen z-0 md:w-screen object-cover "
        //     poster={isMobile ? newMobileHeroImage : newHeroImage}
        //     autoPlay
        //     playsInline
        //     loop
        //     muted
        //     preload="metadata"
        //   ></video>
        // </Slide>
        <img
          src={isMobile ? newMobileHeroImage : web_hero_img}
          alt="image-rendering"
          clssName="w-screen h-auto"
        />
      ),
    },
  ];

  const [showExperinece, setShowExperience] = useState(false);
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const [showStartDialog, setShowStartDialog] = useState(false);
  const [clickFrom, setClickFrom] = useState();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState();
  const [dob, setDob] = useState("");

  // POST FITNESS AGE
  const loadUserData = async () => {
    if (firstName && lastName && mobile && dob) {
      window.dataLayer = window.dataLayer || [];
      (window.dataLayer).push({
        customerFirstName: firstName,
        customerLastName: lastName,
        customerEmail: "",
        cutomerCompanyName: "",
        customerPhone: mobile,
        customerBillingAddress1: "",
        customerBillingAddress2: "",
        customerBillingCity: "",
        customerState: "",
        customerBillingPostcode: "",
        customerBillingCountry: "",
        event: "demo_start",
        });
        let leadData = {};
    const ipDetails = await getIpDetials();
    if (ipDetails) {
      leadData.user_city = ipDetails.ip;
      leadData.user_city = ipDetails.city;
      leadData.user_state = ipDetails.region;
      leadData.user_country = ipDetails.country;
      leadData.user_calling_code = ipDetails.country_calling_code;
    }
    leadData.first_name = firstName;
    leadData.last_name = lastName;
    leadData.mobile = mobile;
    leadData.dob = dob
    .toLocaleString("en-us", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    
    console.log(leadData);
    await postCreateLead(leadData);
      window.location.href =
        // "https://http://app.getactyvphysio.com?firstName=" +
        "/Wellness?firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&mobile=" +
        mobile +
        "&dob=" +
        dob
          .toLocaleString("en-us", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3") +
        "&ref=heroSection";
    }
  };

  return (
    <div className="relative h-screen w-full z-0 bg-no-repeat">
      <CustomDialog
        show={showExperinece}
        close={() => {
          setShowExperience(false);
        }}
      >
        <Dialog.Panel className={"relative"}>
          <div
            onClick={() => {
              setShowExperience(false);
            }}
            className="cursor-pointer bg-[#d9d9d9] rounded-full absolute -right-2 md:-right-5 -top-2 md:-top-5 w-10 h-10 z-10 justify-center items-center flex"
          >
            <Icon icon="carbon:close" className="h-6 w-6" />
          </div>
          <TestYourFitness />
        </Dialog.Panel>
      </CustomDialog>

      <UserDetailsPopUp
        fitnessAge={true}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        setMobile={setMobile}
        setDob={setDob}
        mobile={mobile}
        dob={dob}
        show={showStartDialog}
        // close={() => {
        //   setShowStartDialog(false);
        // }}
        // onClickNext={() => {
        //   loadUserData();
        // }}
        close={() => {
          setShowStartDialog(false);
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
        onClickNext={(e) => {
          loadUserData();
          e.preventDefault();
          // Clear input fields
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
      />
      <div className="z-30 absolute top-0">
        {slides[slideNumber].title}
        {/* <div>
          <p className="capitalize font-poppins  text-white font-extrabold text-5xl md:text-9xl leading-none px-5 md:px-32 mt-20">
            <span className="text-primary-orange italic">ACE </span>YOUR <br />
            HEALTH
          </p>
          <p className="font-open-sans mt-2 text-white text-xl md:text-3xl font-bold px-5 md:px-32 ">
            with our AI based coach
          </p>
        </div> */}
        <p className="font-open-sans mt-2 font-bold text-white text-xl md:text-3xl px-5 md:px-32 "></p>
        <div
          className="max-w-max z-5 mt-5 mx-5 md:mx-32 py-4 text-black cursor-pointer font-poppins text-base font-medium rounded bg-primary-neonGreen px-5 "
          onClick={() => {
            // setShowExperience(true);
            // window.location.href = "https://http://app.getactyvphysio.com/login";
            // setShowAuthDialog(true);
            // setClickFrom("hero_button");
            setShowStartDialog(true);
            // window.location.href =
            //   "https://getactyv.com/newLogin?ref=hero_button";
            // setClickFrom("nav_login");
            // trackingPoint();
          }}
        >
          Start Free Trial
          {/* Fitness Tests */}
        </div>
        <AuthDialog open={showAuthDialog} setOpen={setShowAuthDialog} />
      </div>
      {/* <div
        className="absolute h-full w-screen bg-primary-midBlack top-0 bg-opacity-50 bg-no-repeat"
        style={{ backgroundImage: `url(${hero_image})` }}
      ></div> */}
      <div className="absolute h-screen w-full bg-primary-midBlack top-0 bg-opacity-10 z-10"></div>
      {slides[slideNumber].component}
      {/* <img src="hero_image" alt="rendering" /> */}
    </div>
  );
}

function GetactyvStats() {
  function Stats({ value, prefix, text, index }) {
    const [counter, setCounter] = useState(0);

    const [ref, inView] = useInView({});

    useEffect(() => {
      if (value) {
        if (inView) {
          let start = counter;
          const end = value;
          if (start == end) return;
          let totalMilSecDuration = 2;
          let incrementTime = (totalMilSecDuration / end) * 1000;

          let timer = setInterval(() => {
            if (value > 1000) {
              start += 100;
            } else {
              start += 1;
            }
            if (start >= end) {
              start = end;
            }
            setCounter(start);
            if (start == end) clearInterval(timer);
          }, incrementTime);
        }
      } else {
        setCounter(null);
      }
    }, [inView]);

    return (
      <div className="flex flex-col flex-1" id={`stats-${index}`} ref={ref}>
        <p className="font-poppins text-white text-opacity-80 text-4xl md:text-5xl font-extrabold">
          {counter}
          <span>{prefix}</span>
        </p>
        <p className="font-open-sans text-white text-sm md:text-xl text-opacity-50">
          {text}
        </p>
      </div>
    );
  }
  const isMobile = useIsMobile();
  const [ref, inView] = useInView({ threshold: 0.25 });

  useEffect(() => {
    const element = document.getElementById("heading-how-it-works");
    if (inView) {
      element?.classList.add("text-primary-neonGreen");
    } else {
      element?.classList.remove("text-primary-neonGreen");
    }
  }, [inView]);

  return (
    <div
      className="w-full px-5 md:px-32 py-10 md:py-20 "
      id="section-how-it-works"
      ref={ref}
    >
      {/* <MarketingFitness className="mt-0" /> */}
      <div className="grid grid-cols-2 md:grid-cols-4 mt-20 gap-4">
        {[
          { value: 100, prefix: "%", text: "secure" },
          { value: 105, prefix: "", text: "exercises" },
          { value: 3000, prefix: "", text: "recommended programs" },
          { value: 30000, prefix: "", text: "user created routines" },
          // { value: 80, prefix: "%", text: "Accuracy rate" },
        ].map((stat, index) => {
          return <Stats {...stat} index key={index} />;
        })}
      </div>

      <div className="w-full h-[1px] bg-primary-white bg-opacity-50 mt-10"></div>

      <Fade up duration={700}>
        <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 items-center mt-10 md:mt-20">
          <p className="font-poppins text-white font-bold text-3xl md:text-5xl leading-snug w-full md:w-1/2 ">
            The <span className="text-primary-neonGreen">science</span>
            <br />
            behind {!isMobile && <br />}
            every move
          </p>
          <div className="space-y-1">
            {[
              "GetActyv's proprietary Perfect Pose Vision tech powers the virtual personal trainer that provides expert guidance",
              "Real-time feedback, and motivation",
              "Pushing you to achieve your best",
            ].map((text) => {
              return (
                <p className="font-sans flex flex-row flex-1 text-white leading-8 text-opacity-70">
                  <span className="mr-2 mt-1">
                    <img src={ic_tick} />
                  </span>
                  <span className="flex flex-1">{text}</span>
                </p>
              );
            })}
            <img
              src={perfect_vision_logo}
              alt="image-loading"
              className="ml-2"
            />
          </div>
        </div>
      </Fade>
    </div>
  );
}

function GetactyvVideo() {
  const videoNode = useRef();

  const videoJsOptions = {
    controls: true,
    responsive: true,
    fluid: true,
    preload: "auto",
    poster: "https://getactyvfitness.blob.core.windows.net/Ghostwhite.png",
    // poster: "https://upugo-images.s3.ap-south-1.amazonaws.com/Ghostwhite.png",
    sources: [
      {
        src: "https://getactyvfitness.blob.core.windows.net/old-videos/GetactyvTrim.mp4",
        type: "video/mp4",
      },
    ],
  };
  useEffect(() => {
    const player = videojs(videoNode.current, videoJsOptions, () => {});
    return () => {
      // player.dispose();
    };
  }, []);

  const [ref, inView] = useInView({ threshold: 0.25 });

  useEffect(() => {
    const element = document.getElementById("heading-about-us");
    if (inView) {
      element?.classList.add("text-primary-neonGreen");
    } else {
      element?.classList.remove("text-primary-neonGreen");
    }
  }, [inView]);

  return (
    <div className="w-full" id="section-about-us" ref={ref}>
      <Fade up duration={700}>
        <div className="w-full">
          <video
            id="video"
            ref={videoNode}
            poster={"https://getactyvfitness.blob.core.windows.net/Ghostwhite.png"}
            className=" video-js  vjs-big-play-centered w-screen object-cover"
            onEnded={() => {
              videoNode.current.load();
            }}
          />
        </div>
      </Fade>
    </div>
  );
}

function GetactyvFeatures() {
  function Feature({ number, feature, align, selected }) {
    return (
      <div
        className={`flex flex-1 flex-col items-${
          align === "left" ? "start" : "end"
        }  ${number == selected ? "" : "opacity-50"} cursor-pointer`}
        onClick={() => {
          updateFeature(number);
        }}
      >
        <div
          className={`flex justify-center items-center text-white w-10 h-10 rounded-full  ${
            selected == number ? "bg-primary-orange" : "bg-primary-purple"
          }`}
        >
          {number}
        </div>
        <div
          className={`font-open-sans text-white font-medium mt-2 text-opacity-80 text-${align}`}
        >
          {feature}
        </div>
      </div>
    );
  }
  function MobileFeature({ number, feature, video, isOpen }) {
    return (
      <div className={`flex flex-1 flex-col gap-5`}>
        <React.Fragment key={number}>
          <button
            className="flex w-full justify-center items-center gap-5 rounded-lg px-4 py-2 text-left"
            aria-expanded={isOpen}
            {...(isOpen && { "aria-controls": number })}
          >
            <div
              className={`flex justify-center items-center text-white w-10 h-10 rounded-full bg-primary-purple`}
            >
              {number}
            </div>
            <div
              className={`flex flex-1 font-open-sans text-white font-medium text-opacity-80 `}
            >
              {feature}
            </div>
            {/* <Icon
              icon="charm:chevron-right"
              className={`flex text-primary-white ${
                isOpen ? "rotate-90 transform" : " -rotate-90"
              }`}
            /> */}
          </button>
          {isOpen && (
            <div className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <img
                className="w-64 h-64 object-cover rounded-full "
                src={video}
              />
            </div>
          )}
        </React.Fragment>
      </div>
    );
  }

  function getCoordinate(radians, radius) {
    return { x: Math.sin(radians) * radius, y: Math.cos(radians) * radius };
  }

  const [selectedFeature, setSelectedFeature] = useState({
    feature: 1,
    progress: 150,
  });

  const features = [
    {
      number: 1,
      feature: "No sensors, consoles or wearables required",
      align: "right",
      isOpen: true,
      video: "https://ik.imagekit.io/getactyv/images/features/no-sensors.webp",
    },
    {
      number: 2,
      feature: "Recommendations based on difficulty level and desired goals",
      align: "right",
      isOpen: true,
      video: "https://ik.imagekit.io/getactyv/images/features/3.webp",
      // video: "https://ik.imagekit.io/getactyv/images/features/2.webp",
    },
    {
      number: 3,
      feature: "Synchronous feedback with real-time guidance",
      isOpen: true,
      align: "right",
      video: "https://ik.imagekit.io/getactyv/images/features/2.webp",
      // video: "https://ik.imagekit.io/getactyv/images/features/3.webp",
    },

    {
      number: 4,
      feature: "Movement-led gaming",
      isOpen: true,
      align: "left",
      video: "https://ik.imagekit.io/getactyv/images/features/4.webp",
    },

    {
      number: 5,
      feature: "Workouts for workplace",
      isOpen: true,
      align: "left",
      video: "https://ik.imagekit.io/getactyv/images/features/5.webp",
    },
    {
      number: 6,
      feature: "∞ Flexibility to Create Your Own Routines",
      isOpen: true,
      align: "left",
      video: "https://ik.imagekit.io/getactyv/images/features/6.webp",
    },
  ];

  const isMobile = useIsMobile();

  const [ref, inView] = useInView({ threshold: 0.25 });
  const updateFeature = (feature) => {
    setSelectedFeature((prevState) => {
      const newFeature = feature
        ? feature
        : (prevState.feature + 1) % 6 == 0
        ? 6
        : (prevState.feature + 1) % 6;
      const arc =
        (2 *
          Math.PI *
          192 *
          (newFeature > 3 ? newFeature + 1 : newFeature) *
          45) /
        360;

      return {
        feature: newFeature,
        progress:
          arc > 1055
            ? 1200
            : arc > 904
            ? 904
            : arc > 753
            ? 753
            : arc > 452
            ? 452
            : arc > 301
            ? 301
            : 150,
      };
    });
  };
  useEffect(() => {
    if (!isMobile) {
      setInterval(() => {
        updateFeature(null);
      }, 3000);
    }
  }, []);

  useEffect(() => {
    const element = document.getElementById("heading-features");
    if (inView) {
      element?.classList.add("text-primary-neonGreen");
    } else {
      element?.classList.remove("text-primary-neonGreen");
    }
  }, [inView]);

  return (
    <div
      className="w-full  overflow-scroll no-scrollbar px-5 md:px-32 py-20"
      id="section-features"
    >
      <div className="" ref={ref}>
        {/* <p className="font-poppins text-white font-bold text-4xl leading-snug md:text-center">
          Redefine your game plan for a{" "}
          <span className="text-primary-orange">healthier life</span>
        </p> */}
        <p className="font-poppins text-white font-bold text-4xl leading-snug md:text-center">
          GetActyv's AI-based personal trainer is here to revolutionize your{" "}
          <span className="text-primary-orange">fitness journey</span>
        </p>
        {/* <p className="font-open-sans mt-2 text-white text-opacity-80 text-base md:text-center">
          Motivation. Discipline. Determination. Progress. Goals.
        </p> */}
      </div>
      {!isMobile && (
        <div className="flex flex-row mt-24">
          <div className="flex flex-col flex-1 gap-5">
            {[
              {
                number: 1,
                feature: "No sensors, consoles or wearables required",
                align: "right",
              },
              {
                number: 2,
                feature: "Synchronous feedback with real-time guidance",
                align: "right",
              },
              {
                number: 3,
                feature:
                  "Recommendations based on difficulty level and desired goals",
                align: "right",
              },
            ].map((feature) => {
              return (
                <Feature {...feature} selected={selectedFeature.feature} />
              );
            })}
          </div>
          <div className="relative flex w-3/5 justify-center items-center">
            <div
              style={{
                top: getCoordinate(Math.PI / 6, 192).x / 2,
              }}
              className={`left-4 mt-2 absolute w-48 h-[1px] rounded-full border-[#FFFFFF26] border-[1px] border-spacing-6 border-white border-dashed`}
            />
            <div
              className={`left-4 absolute w-48 h-[1px] rounded-full border-[#FFFFFF26] border-[1px] border-spacing-6 border-white border-dashed`}
            />
            <div
              style={{
                bottom: getCoordinate(Math.PI / 6, 192).x / 2,
              }}
              className={`left-4 mb-2 absolute w-48 h-[1px] rounded-full border-[#FFFFFF26] border-[1px] border-spacing-6 border-white border-dashed`}
            />
            <div
              style={{
                top: getCoordinate(Math.PI / 6, 192).x / 2,
              }}
              className={`right-4 mt-2 absolute w-48 h-[1px] rounded-full border-[#FFFFFF26] border-[1px] border-spacing-6 border-white border-dashed`}
            />
            <div
              className={`right-4 absolute w-48 h-[1px] rounded-full border-[#FFFFFF26] border-[1px] border-spacing-6 border-white border-dashed`}
            />
            <div
              style={{
                bottom: getCoordinate(Math.PI / 6, 192).x / 2,
              }}
              className={`right-4 mb-2 absolute w-48 h-[1px] rounded-full border-[#FFFFFF26] border-[1px] border-spacing-6 border-white border-dashed`}
            />

            <div className="relative rounded-full z-1 bg-primary-midBlack  w-96 h-96 flex  justify-center items-center">
              <div className="absolute -scale-y-100 w-96 h-96">
                <CircularProgressbar
                  value={selectedFeature.progress}
                  maxValue={1200}
                  strokeWidth={1}
                  styles={buildStyles({
                    rotation: 0.5,
                    // How long animation takes to go from one percentage to another, in seconds
                    pathTransitionDuration: 0.5,

                    // Can specify path transition in more detail, or remove it entirely
                    // pathTransition: 'none',

                    // Colors
                    pathColor: `#FFFFFF`,
                    trailColor: "#FFFFFF26",
                  })}
                />
              </div>
              <div
                style={{
                  left: getCoordinate(Math.PI / 3, 192).y / 2,
                  top: getCoordinate(Math.PI / 6, 192).x / 2,
                }}
                className={` absolute w-4 h-4 rounded-full ${
                  selectedFeature.feature == 1
                    ? "bg-primary-orange"
                    : "bg-primary-purple"
                }`}
              />
              <div
                className={`left-0 -ml-2 absolute w-4 h-4 rounded-full ${
                  selectedFeature.feature == 2
                    ? "bg-primary-orange"
                    : "bg-primary-purple"
                }`}
              />
              <div
                style={{
                  left: getCoordinate(Math.PI / 3, 192).y / 2,
                  bottom: getCoordinate(Math.PI / 6, 192).x / 2,
                }}
                className={` absolute w-4 h-4 rounded-full ${
                  selectedFeature.feature == 3
                    ? "bg-primary-orange"
                    : "bg-primary-purple"
                }`}
              />
              <div
                style={{
                  right: getCoordinate(Math.PI / 3, 192).y / 2,
                  bottom: getCoordinate(Math.PI / 6, 192).x / 2,
                }}
                className={` absolute w-4 h-4 rounded-full ${
                  selectedFeature.feature == 4
                    ? "bg-primary-orange"
                    : "bg-primary-purple"
                }`}
              />
              <div
                className={`right-0 -mr-2 absolute w-4 h-4 rounded-full ${
                  selectedFeature.feature == 5
                    ? "bg-primary-orange"
                    : "bg-primary-purple"
                }`}
              />
              <div
                style={{
                  right: getCoordinate(Math.PI / 3, 192).y / 2,
                  top: getCoordinate(Math.PI / 6, 192).x / 2,
                }}
                className={` absolute w-4 h-4 rounded-full ${
                  selectedFeature.feature == 6
                    ? "bg-primary-orange"
                    : "bg-primary-purple"
                }`}
              />
              <img
                className="w-80 h-80 object-cover rounded-full "
                src={features[selectedFeature.feature - 1].video}
              />
            </div>
          </div>
          <div className="flex flex-col flex-1 gap-5">
            {[
              {
                number: 6,
                feature: "∞ flexibility to create your own routines",
                align: "left",
              },

              {
                number: 5,
                feature: "Workouts for workplace",
                align: "left",
              },
              {
                number: 4,
                feature: "Motion sensor enabled gaming",
                align: "left",
              },
            ].map((feature) => {
              return (
                <Feature {...feature} selected={selectedFeature.feature} />
              );
            })}
          </div>
        </div>
      )}
      {isMobile && (
        <div className="flex lg:hidden mt-20">
          {
            <div className="flex flex-col flex-1 gap-5">
              {features.map((feature, index) => {
                return <MobileFeature {...feature} />;
              })}
            </div>
          }
        </div>
      )}
    </div>
  );
}

function GetactyvCohorts() {
  const cohorts = [
    {
      title: "Sports",
      description:
        "Improve strength, power, speed, coordination and flexibility for enhanced physical conditioning",
      description2: "Serve, dunk, hit, bowl flawlessly, and ace every game.",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+2%400.75x-8.png",
    },
    {
      title: "Walk, Run, Cycle",
      description:
        "Strengthen quadriceps, hamstrings, glutes, hip flexors, upper body, and core for repetitive motion sensor enabled monitoring",

      description2: "Move with power and perfection.",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+3%400.75x-8.png",
    },
    {
      title: "Strength and Agility",
      description:
        "Work upper and lower body muscles to improve overall strength and suppleness",

      description2: "Maximize your performance and productivity, all day long.",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+7%400.75x-8.png",
    },
    {
      title: "Weight Loss",

      description2: "Flex every dress. Flaunt every style.",
      description:
        "Elevate metabolism, boost energy expenditure and speed up the fat-burning process",
      image: "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy%400.75x-8.png",
    },
    {
      title: "Stress Buster",
      description:
        "A full body program with the right mix of intensity, movements, and breath control to expand energy levels",

      description2: "Watchout! You’re in a Stress Free zone now.",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+6%400.75x-8.png",
    },
    {
      title: "Flexibility",
      description:
        "Reduce muscle tightness, improve joint stability and mobility",

      description2: "Impress with every move.",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+4%400.75x-8.png",
    },
    {
      title: "Fitness Freak",
      description:
        "Challenge your muscular strength and endurance with this dynamic whole body program",

      description2: "Be a hero. Inspire others.",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/tabata.jpg",
    },
  ];

  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:
  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [scrolEnd, setscrolEnd] = useState(false); // For detecting end of scrolling

  const slide = (shift) => {
    ref.current.scrollLeft += shift;
    setscrollX(scrollX + shift); // Updates the latest scrolled postion
    //For checking if the scroll has ended
    if (
      Math.floor(ref.current.scrollWidth - ref.current.scrollLeft) <=
      ref.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };
  useEffect(() => {
    //Check width of the scollings
    if (
      ref.current &&
      ref?.current?.scrollWidth === ref?.current?.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
    return () => {};
  }, [ref?.current?.scrollWidth, ref?.current?.offsetWidth]);

  const [divRef, inView] = useInView({ threshold: 0.25 });

  useEffect(() => {
    const element = document.getElementById("heading-cohorts");
    if (inView) {
      element?.classList.add("text-primary-neonGreen");
    } else {
      element?.classList.remove("text-primary-neonGreen");
    }
  }, [inView]);

  return (
    <div className="w-full  " id="section-cohorts" ref={divRef}>
      <div className="px-5 md:px-32 pt-20">
        {/* <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug md:text-center">
          Designed for {isMobile && <br />}{" "}
          <span className="text-primary-orange">every workout</span>
        </p> */}
        <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug md:text-center">
          Designed to achieve your {isMobile && <br />}{" "}
          <span className="text-primary-orange">fitness goals</span>
        </p>
        <p className="font-open-sans mt-2 text-white text-opacity-80 text-base md:text-center">
          Motivation. Discipline. Determination. Progress. Goals.
        </p>
      </div>
      <div className="relative">
        {scrollX !== 0 && (
          <div
            className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 left-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
            onClick={() => {
              slide(-350);
            }}
          >
            <Icon
              icon="fluent:arrow-next-12-filled"
              className="text-primary-white h-auto w-5 rotate-180"
            />
          </div>
        )}
        {!scrolEnd && (
          <div
            className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 right-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
            onClick={() => {
              slide(350);
            }}
          >
            <Icon
              icon="fluent:arrow-next-12-filled"
              className="text-primary-white h-auto w-5"
            />
          </div>
        )}
        <ul
          {...events}
          ref={ref}
          className="flex flex-nowrap  py-10 
      overflow-x-scroll cursor-grab scroll-smooth overflow-y-hidden no-scrollbar  pl-4 md:pl-20 2xl:pl-28"
        >
          {cohorts.map((cohort) => {
            return (
              <div className="inline-block px-2 md:px-4 ">
                <div className="relative rounded-lg overflow-clip bg-primary-black h-64 w-44 md:h-80 md:w-64 group">
                  <img
                    src={cohort.image}
                    className="absolute object-cover w-full h-full rounded-lg"
                    loading="lazy"
                  />
                  <div className="absolute bottom-0 w-full h-12 flex flex-col justify-center items-center group-hover:h-auto py-0 group-hover:py-5 px-4 bg-primary-black rounded-t-lg  duration-700">
                    <p className="flex justify-center items-center md:text-lg font-bold text-white text-center">
                      {cohort.title}
                      <span className="group-hover:hidden">
                        <Icon
                          icon="charm:chevron-right"
                          className="-rotate-90"
                        />
                      </span>
                    </p>
                    <p className="text-white text-opacity-0 hidden group-hover:flex group-hover:text-opacity-80 text-center text-sm transition-all duration-300">
                      {cohort.description}
                    </p>
                    <p className="text-white text-opacity-0 hidden group-hover:flex group-hover:text-opacity-80 text-center text-sm transition-all duration-300">
                      {cohort.description2}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

function GetactyvComparison() {
  const isMobile = useIsMobile();
  const [ref, inView] = useInView({
    threshold: 0.25,
  });

  useEffect(() => {
    const element = document.getElementById("heading-comparison");
    if (inView) {
      element?.classList.add("text-primary-neonGreen");
    } else {
      element?.classList.remove("text-primary-neonGreen");
    }
  }, [inView]);
  return (
    <Fade up duration={700}>
      <div
        className="w-full px-5 md:px-32 py-20 "
        id="section-comparison"
        ref={ref}
      >
        <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug md:text-center">
          {/* getactyv - your personal trainer. {isMobile && <br />} */}
          GetActyv - your virtual {isMobile && <br />}
          {/* <span className="text-primary-neonGreen">Find out how?</span> */}
          <span className="text-primary-neonGreen">personal trainer</span>
        </p>
        <p className="font-open-sans mt-2 text-white text-opacity-80 text-base md:text-center">
          Making every move personalised, assisted and measured
        </p>
        <div className="font-open-sans overflow-auto w-full mt-20">
          <table className="table-fixed w-full">
            <thead className="">
              <tr className="text-white font-bold">
                <td className="w-48 md:w-fit"></td>
                <td className=" bg-primary-blue p-1 rounded-t-lg bg-opacity-40 text-center w-32 md:w-fit"></td>
                <td className="w-32 md:w-fit"></td>
                <td className="w-32 md:w-fit"></td>
                <td className="w-32 md:w-fit"></td>
              </tr>
              <tr className="text-white font-bold">
                <td className="bg-[#12141a] rounded-l-lg p-6 sticky z-1 w-48 md:w-fit left-0">
                  Platforms
                </td>
                <td className=" bg-primary-blue bg-opacity-40 text-center w-32 md:w-fit">
                  Getactyv
                </td>
                <td className="bg-[#12141a] w-32 md:w-fit text-center">
                  Other AI Platforms
                </td>
                <td className="bg-[#12141a] w-32 md:w-fit text-center">
                  Digital Fitness Trainers
                </td>
                <td className="bg-[#12141a] w-32 md:w-fit rounded-r-lg text-center">
                  Physical Coaches
                </td>
              </tr>
            </thead>
            <tbody className="relative">
              <tr className="text-white font-medium">
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 rounded-tl-lg p-6 sticky left-0 z-1">
                  Real-time voice command
                </td>
                <td className="bg-primary-blue bg-opacity-40 text-center p-6">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center p-6">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center p-6">
                  <div className="w-full flex justify-center">
                    <img src={ic_cancel} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 rounded-tr-lg text-center p-6">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>
              </tr>
              <tr className="text-white font-medium ">
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 px-6 sticky left-0 z-1">
                  Form Correction
                </td>
                <td className="bg-primary-blue bg-opacity-40 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>

                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center font-normal text-white text-opacity-70 ">
                  Partially available
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_cancel} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5  text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>
              </tr>
              <tr className="text-white font-medium ">
                <td className=" bg-primary-paleBlack md:bg-white md:bg-opacity-5 p-6 sticky left-0 z-1">
                  Progressive and Personalised
                </td>
                <td className="bg-primary-blue bg-opacity-40 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_cancel} />
                  </div>
                </td>

                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_cancel} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>
              </tr>
              <tr className="text-white font-medium ">
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 px-6 pb-6 sticky left-0 z-1 rounded-bl-lg">
                  Gadgets and Sensors
                </td>
                <td className="bg-primary-blue bg-opacity-40 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_cancel} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_tick} />
                  </div>
                </td>

                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center ">
                  <div className="w-full flex justify-center">
                    <img src={ic_cancel} />
                  </div>
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center rounded-br-lg">
                  <div className="w-full flex justify-center">
                    <img src={ic_cancel} />
                  </div>
                </td>
              </tr>
              {/* <tr className="text-white font-medium ">
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 p-6 rounded-bl-lg align-top sticky left-0 z-1">
                  Posture Correction
                </td>
                <td className="bg-primary-blue bg-opacity-40 text-center font-normal text-white text-opacity-70 pb-5 p-6">
                  INR 200 mo to
                  <br /> INR 2000 pa
                  <br /> ($25-30 pa)
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center font-normal text-white text-opacity-70 pb-5 p-6">
                  Between INR 25,000-200,000
                  <br /> $250-300 for device + <br />
                  monthly subscription of $39-79
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 text-center font-normal text-white text-opacity-70 pb-5 p-6">
                  Free
                </td>
                <td className="bg-primary-paleBlack md:bg-white md:bg-opacity-5 rounded-br-lg text-center font-normal text-white text-opacity-70 pb-5 p-6">
                  Between $1500-2500 <br />
                  (INR 120,000-200,000)
                </td>
              </tr> */}
              <tr className="text-white font-bold">
                <td className="w-48 md:w-fit"></td>
                <td className=" bg-primary-blue p-1 rounded-b-lg bg-opacity-40 text-center w-32 md:w-fit"></td>
                <td className="w-32 md:w-fit"></td>
                <td className="w-32 md:w-fit"></td>
                <td className="w-32 md:w-fit"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Fade>
  );
}

export function HealthyLife({ openAuth }) {
  const [showStartDialog, setShowStartDialog] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState();
  const [dob, setDob] = useState("");

  // POST FITNESS AGE
  const loadUserData = async () => {
    if (firstName && lastName && mobile && dob) {
      window.location.href =
        // "https://http://app.getactyvphysio.com?firstName=" +
        "/Wellness?firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&mobile=" +
        mobile +
        "&dob=" +
        dob
          .toLocaleString("en-us", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3") +
        "&ref=healthyLife";
    }
  };

  const Indicator = ({ text, showLine, number }) => (
    <div className={`flex flex-col w-full `}>
      <div className="flex flex-row w-full items-center">
        <div
          className={`flex items-center justify-center rounded-full h-[60px] w-[60px] p-1 bg-white bg-opacity-5 `}
        >
          <div
            className={`flex items-center justify-center text-white text-lg md:text-xl font-bold leading-relaxed rounded-full h-[40px] w-[40px] p-1 shadow-xl bg-white bg-opacity-5 `}
          >
            {number}
          </div>
        </div>
        {showLine && (
          <div className=" w-full flex-1 bg-customGray-100 h-[2px] bg-opacity-50 rounded-md flex items-center "></div>
        )}
      </div>
      <p className={`font-open-sans font-bold text-white md:text-xl `}>
        {text}
      </p>
    </div>
  );

  return (
    <div
      style={{ backgroundImage: `url(${healthyLife})` }}
      className=" w-full bg-no-repeat bg-cover bg-center"
    >
      <UserDetailsPopUp
        fitnessAge={true}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        setMobile={setMobile}
        setDob={setDob}
        mobile={mobile}
        dob={dob}
        show={showStartDialog}
        // close={() => {
        //   setShowStartDialog(false);
        // }}
        // onClickNext={() => {
        //   loadUserData();
        // }}
        close={() => {
          setShowStartDialog(false);
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
        onClickNext={(e) => {
          loadUserData();
          e.preventDefault();
          // Clear input fields
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
      />
      <Fade up duration={700}>
        <div className="flex flex-col md:flex-row space-y-5 md:space-y-0 px-5 md:px-32 py-8 md:py-20 ">
          <div className="flex flex-1 flex-col">
            {/* <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
              3-steps
              <br></br> for a{" "}
              <span className="text-primary-orange">healthy life</span>
            </p> */}
            <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
              Three steps
              <br></br> for a{" "}
              <span className="text-primary-orange">fitter you</span>
            </p>
            <div
              className="hidden md:flex max-w-max mt-5 text-black cursor-pointer font-poppins text-base font-medium rounded bg-primary-neonGreen px-5 py-4"
              onClick={() => {
                // openAuth();
                // window.location.href =
                //   "https://getactyv.com/newLogin?ref=healthyLife_button";
                setShowStartDialog(true);
              }}
            >
              Start Free Trial
            </div>
          </div>
          <div className="flex flex-row justify-between">
            <Indicator showLine text="Register your details" number={1} />
            <Indicator
              showLine
              text="Get a personalised program(s)"
              number={2}
            />
            <Indicator text="Perform. Progress. Repeat" number={3} />
          </div>
          <div
            className="md:hidden max-w-max mt-5 self-start text-black cursor-pointer font-poppins text-base font-medium rounded bg-primary-neonGreen px-5 py-4"
            onClick={() => {
              // openAuth();
              window.location.href =
                "https://getactyv.com/newLogin?ref=healthyLife_button";
            }}
          >
            Start Free Trial
          </div>
        </div>
      </Fade>
    </div>
  );
}

export function StartFreeTrail({ openAuth }) {
  const isMobile = useIsMobile();
  const [showStartDialog, setShowStartDialog] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState();
  const [dob, setDob] = useState("");

  // POST FITNESS AGE
  const loadUserData = async () => {
    if (firstName && lastName && mobile && dob) {
      window.location.href =
        // "https://http://app.getactyvphysio.com?firstName=" +
        "/Wellness?firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&mobile=" +
        mobile +
        "&dob=" +
        dob
          .toLocaleString("en-us", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3") +
        "&ref=startFreeTrialBanner";
    }
  };
  return (
    <div className="w-full px-5 md:px-32 py-20">
      <UserDetailsPopUp
        fitnessAge={true}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        setMobile={setMobile}
        setDob={setDob}
        mobile={mobile}
        dob={dob}
        show={showStartDialog}
        // close={() => {
        //   setShowStartDialog(false);
        // }}
        // onClickNext={() => {
        //   loadUserData();
        // }}
        close={() => {
          setShowStartDialog(false);
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
        onClickNext={(e) => {
          loadUserData();
          e.preventDefault();
          // Clear input fields
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
      />
      <Fade up duration={700}>
        <div className="relative flex flex-row overflow-clip bg-[#0B0F19] rounded-lg w-full">
          <div className="absolute top-0 md:left-16 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
          <div className="absolute -bottom-20 -right-10 md:right-0 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
          <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 items-center rounded-lg px-5 md:px-28 py-8 md:py-20 backdrop-blur-3xl w-full">
            <div className="flex flex-1 flex-col w-full">
              {/* <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
                <span className="text-primary-neonGreen">Jumpstart</span> your
                <br></br>
                healthy lifestyle
              </p> */}{" "}
              <p className="font-poppins text-primary-neonGreen font-bold text-3xl md:text-4xl leading-snug">
                <span className="text-white">It's time to transform</span>{" "}
                <br></br>
                your fitness journey
              </p>
              <p className="font-open-sans mt-2 text-white text-opacity-70 font-medium text-lg md:text-xl">
                with our free 30-day trial
              </p>
              {!isMobile && (
                <div
                  className="max-w-max mt-5 text-black cursor-pointer font-poppins text-base font-medium rounded bg-primary-neonGreen px-5 py-4"
                  onClick={() => {
                    // openAuth();
                    // window.location.href =
                    //   "https://getactyv.com/newLogin?ref=startFreeTrial_button";
                    setShowStartDialog(true);
                  }}
                >
                  Start Free Trial
                </div>
              )}
            </div>
            <div className="space-y-1">
              {[
                "Program recommendations based on difficulty level and desired goals",
                "Access to the entire range of workout programs and games",
                "Access to motion sensor enabled games",
                "Personalised performance analytics",
                "Physical therapy workouts",
                "Progress tracking",
              ].map((text) => {
                return (
                  <p className="font-open-sans leading-8 flex flex-row  text-white text-opacity-70">
                    <span className="mt-1 mr-2">
                      <img src={ic_tick} />
                    </span>
                    <span className="flex flex-1">{text}</span>
                  </p>
                );
              })}
            </div>
            {isMobile && (
              <div
                className="max-w-max mt-5 self-start text-black cursor-pointer font-poppins text-base font-medium rounded bg-primary-neonGreen px-5 py-4"
                onClick={() => {
                  // openAuth();
                  window.location.href =
                    "https://getactyv.com/newLogin?ref=startfreeTrial_button";
                }}
              >
                Start Free Trial
              </div>
            )}
          </div>
        </div>
      </Fade>
    </div>
  );
}

function TestimonialSection() {
  return (
    <div className="w-full  py-20">
      <div className="px-5 md:px-32">
        <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug md:text-center">
          Success <span className="text-primary-neonGreen">Stories</span>
        </p>
        <p className="font-open-sans mt-2 text-white text-opacity-80 text-base md:text-center">
          from people just like you
        </p>
        <Testimonials />
      </div>
    </div>
  );
}

function FreeTrialLanding() {
  const auth = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const pathname = window.location.href;
  sessionStorage.setItem("utm_url", pathname);
  Cookies.set("currentUrl", window.location.href);

  useEffect(() => {
    if (auth.state.user) {
      if (!location.state?.from?.search) {
        navigate("/programpage");
      }
    }
  }, [auth.state]);

  const [showAuth, setShowAuth] = useState(false);

  function hashLocation() {
    const hash = window.location.hash;
    switch (hash) {
      case "#section-how-it-works":
        document.getElementById("heading-how-it-works").click();
        break;
      case "#features":
        document.getElementById("section-features").scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "#cohorts":
        document.getElementById("section-cohorts").scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "#comparisons":
        document.getElementById("section-comparison").scrollIntoView({
          behavior: "smooth",
        });
        break;
      default:
    }
  }

  useEffect(() => {
    hashLocation();
  }, []);

  return (
    <div className="flex flex-col w-full h-full bg-primary-midBlack">
      <AuthDialog open={showAuth} setOpen={setShowAuth} />

      {/* {isMobile ? <ExitIntentMobile /> : <ExitIntentPopup />} */}
      {/* <ExitIntentMobile /> */}
      {/* <ExitIntentPopup /> */}
      {/* <MobilePopup /> */}
      {/* <MobPopup /> */}

      <ProductHunt />

      <HeroSection
        openAuth={() => {
          setShowAuth(true);
        }}
      />
      <div className="bg-primary-midBlack">
        <a id="how-it-works">
          <GetactyvStats />
        </a>
        <a id="about-us">
          <GetactyvVideo />
        </a>
        <a id="features">
          <GetactyvFeatures />
        </a>
        <a id="cohorts">
          <GetactyvCohorts />
        </a>
        {!isMobile && (
          <a id="comparisons">
            <GetactyvComparison />
          </a>
        )}
        <TestimonialSection />
        <HealthyLife
          openAuth={() => {
            setShowAuth(true);
          }}
        />
        <StartFreeTrail
          openAuth={() => {
            setShowAuth(true);
          }}
        />
      </div>
    </div>
  );
}

export default FreeTrialLanding;
